import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import './GuestRegistration.component.scss';

import { createGuestUser } from '../../services/user.service';
import Regexp from '../../constants/regexp';
import { getAtoZList } from "../../services/utils.service";

const AtoZList = getAtoZList();


function GuestRegistration({ isGuestUser, orderId, setGuestUserSubmitted, musicStudioOrderItems }) {

    const registerDefaultValues = {
        // firstName: '',
        // lastName: '',
        // phoneNumber: '',
        // email: '',
    };
    const [isRequestAlive, setIsRequestAlive] = useState(false);
    const { register, handleSubmit, formState: { errors, isDirty, isValid, touchedFields }, reset, clearErrors } = useForm({
        mode: 'all',
        defaultValues: registerDefaultValues
    });

    // To keep track of which music studio items are selected
    const [selectedItems, setSelectedItems] = useState({});
    // Handle checkbox change
    const handleCheckboxChange = (msoItem) => {
        setSelectedItems((prevState) => {
            const msoItemChecked = !prevState[msoItem._id];
            // clear errors when selectedItems changes
            const msAssetId = msoItem.musicStudioAssetId._id;
            // If checkbox is unchecked, clear errors for that student
            if (!msoItemChecked) {
                clearErrors(`students[${msAssetId}]`); // Clear errors for that student
            }
            return {
                ...prevState,
                [msoItem._id]: msoItemChecked, // Fix here: msoItem._id instead of msoItem
            };
        });
    };


    // Student Name validation function
    const validateStudentName = (value) => {
        if (!value) return 'Name is required';
        if (value.length < 2 || value.length > 50) return 'Name must be between 2 and 50 characters';
        if (!/^[a-zA-Z\s]+$/.test(value)) return 'Name can only contain letters and spaces';
        return true; // Valid
    }

    // Age validation function
    const validateAge = (value) => {
        if (!value) return 'Age is required';
        if (value < 1 || value > 100) return 'Age must be between 1 and 100';
        return true; // Valid
    };

    // Email validation function
    const validateEmail = (value) => {
        if (!value) return 'Email is required';
        const emailPattern = Regexp._EMAIL;
        if (!emailPattern.test(value)) return 'Please enter a valid email';
        return true; // Valid
    };


    const onSubmit = (data, e) => {
        e.preventDefault();
        try {
            if (isRequestAlive) return;
            if ((!isGuestUser && !isDirty && isValid)) {
                setGuestUserSubmitted(true);
            }

            if (!isValid || !isDirty || isRequestAlive) {
                return;
            } else {
                const { students, ...remainBody } = data;
                const body = {
                    orderId,
                    ...remainBody
                };

                // Add student details to the body based on selected items
                body.students = Object.keys(selectedItems).reduce((acc, itemId) => {
                    if (selectedItems[itemId]) {
                        const msAssetId = musicStudioOrderItems.find(msoItem => msoItem._id === itemId)?.musicStudioAssetId?._id;
                        if (msAssetId && students[msAssetId]) {
                            acc[msAssetId] = students[msAssetId];
                        }
                    }
                    return acc;
                }, {});

                setIsRequestAlive(true);
                createGuestUser(body).then((res) => {
                    if (res.data.code === 'CREATED') {
                        reset(registerDefaultValues);
                        setGuestUserSubmitted(true);
                    }
                    setIsRequestAlive(false);
                }).catch((err) => {
                    setIsRequestAlive(false);
                    console.log('Error while create guest user', err);
                });
            }
        } catch (error) {
            setIsRequestAlive(false);
            console.log(`Error while create guest user`, error);
        }
    }


    return (
        <form className='guest-form-wrapper' onSubmit={handleSubmit((data, e) => onSubmit(data, e))} autoComplete="off">
            <div className='guest-form'>
                {isGuestUser && <>
                    <div className='guest-form-header'>
                        <h2 className='guest-form-header-title'>Please provide details below -</h2>
                    </div>
                    <div className='guest-form-body'>
                        <div>
                            <div className='guest-form-body-item'>
                                <input className='guest-form-body-item-input' type='text' name='firstName' placeholder='first name'
                                    {...register('firstName', { required: 'This field is required.' })} />
                            </div>
                            {
                                (touchedFields.firstName && errors.firstName) && (<h4 className='guest-form-body-item-err-msg'>
                                    {errors.firstName.message}
                                </h4>)
                            }
                        </div>
                        <div>
                            <div className='guest-form-body-item'>
                                <input className='guest-form-body-item-input' type='text' name='lastName' placeholder='last name'
                                    {...register('lastName', { required: 'This field is required.' })} />
                            </div>
                            {
                                (touchedFields.lastName && errors.lastName) && (<h4 className='guest-form-body-item-err-msg'>
                                    {errors.lastName.message}
                                </h4>)
                            }
                        </div>
                        <div>
                            <div className='guest-form-body-item'>
                                <input className='guest-form-body-item-input' type='text' name='phoneNumber' placeholder='contact number'
                                    {...register('phoneNumber', {
                                        required: 'Contact Number is required.',
                                        pattern: {
                                            value: Regexp._MOBILE_NUMBER,
                                            message: 'Please enter valid contact number.'
                                        }
                                    })} />
                            </div>
                            {
                                errors.phoneNumber && (<h4 className='guest-form-body-item-err-msg'>
                                    {errors.phoneNumber.message}
                                </h4>)
                            }
                        </div>
                        <div>
                            <div className='guest-form-body-item'>
                                <input className='guest-form-body-item-input' type='text' name='email' placeholder='email'
                                    {...register('email', {
                                        required: 'This field is required.',
                                        pattern: {
                                            value: Regexp._EMAIL,
                                            message: 'Please enter a valid e-mail address.'
                                        }
                                    })} />
                            </div>
                            {
                                (touchedFields.email && errors.email) && (<h4 className='guest-form-body-item-err-msg'>
                                    {errors.email.message}
                                </h4>)
                            }
                        </div>
                    </div>
                </>}
                {musicStudioOrderItems.length > 0 && musicStudioOrderItems.map((msoItem) => (
                    <div key={msoItem._id} className="music-studio-class-name-wrapper">
                        <div className="music-studio-class-name-checkbox-wrapper">
                            {/* Checkbox for selecting the music studio item */}
                            <label className="music-studio-class-name-checkbox">
                                {selectedItems[msoItem._id] ?
                                    <svg className="ms-cn-checkbox-icon" width="34" height="34" viewBox="0 0 162 162" fill="none">
                                        <g id="Group">
                                            <path id="Vector"
                                                d="M132.319 0H29.6772L0 29.6772V132.319L29.6772 161.933H132.319L161.933 132.319V29.6772L132.319 0Z"
                                                fill="#DAFF00"></path>
                                            <path id="Vector_2"
                                                d="M123.687 44.5474H115.243L65.4032 94.3875L46.8156 75.7368H38.2463L33.0796 80.9036V89.3468L61.1186 117.386H69.6248L128.664 58.2203L128.727 56.9602C128.79 54.6288 128.79 53.3056 128.79 51.0373V49.7141L123.687 44.5474Z"
                                                fill="#282727"></path>
                                        </g>
                                    </svg> :
                                    <svg className="ms-cn-checkbox-icon" width="34" height="34" viewBox="0 0 34 34" fill="none">
                                        <g>
                                            <rect width="34" height="34" transform="translate(0 0)" fill="black"></rect>
                                            <g id="Group 131">
                                                <path id="Vector"
                                                    d="M27.7592 0H6.25409L0 6.25409V27.7592L6.25409 34H27.7592L34 27.7592V6.25409L27.7592 0ZM8.34762 28.9119L5.08808 25.6524V8.34762L8.34762 5.08808H25.6391L28.8987 8.34762V25.6391L25.6391 28.8987H8.34762V28.9119Z"
                                                    fill="#ffffff"></path>
                                            </g>
                                        </g>
                                    </svg>
                                }
                                <input className="ms-cn-checkbox-input" type="checkbox" checked={selectedItems[msoItem._id] || false} onChange={() => handleCheckboxChange(msoItem)} />
                                <span className="music-studio-class-name-label">
                                    {`Provide student details for ${msoItem.musicStudioAssetId.name}`}
                                </span>
                            </label>
                        </div>

                        {/* Render student details if the class is selected */}
                        {/* Table for student details */}
                        { selectedItems[msoItem._id] &&
                        <table className="student-form-details-table">
                            <thead>
                                <tr>
                                    <th className="student-name-header">
                                        <span className="student-name-header-text">
                                            Name of student
                                        </span>
                                    </th>
                                    <th className="student-name-header small-cell">
                                        <span className="student-name-header-text">
                                            Age of student
                                        </span>
                                    </th>
                                    <th className="student-name-header">
                                        <span className="student-name-header-text">
                                            Student email address
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.from({ length: msoItem.peoples }).map((_, studentIndex) => (
                                    <tr key={studentIndex} className="student-form-details-row">
                                        {/* Name input field */}
                                        <td className="student-name-input-wrapper">
                                            <input type="text"
                                                className={`student-name-input ${errors?.students?.[msoItem.musicStudioAssetId._id]?.[studentIndex]?.studentName ? 'invalid-class' : ''}`} // Apply invalid-class conditionally
                                                {...register(`students[${msoItem.musicStudioAssetId._id}][${studentIndex}].studentName`, {
                                                    // Apply validation if checkbox is selected
                                                    validate: selectedItems[msoItem._id] ? (value) => validateStudentName(value) : undefined,
                                                })}
                                                placeholder="Student name"
                                            />
                                        </td>

                                        {/* Age input field with validation */}
                                        <td className="student-name-input-wrapper">
                                            <input type="number"
                                                className={`student-name-input ${errors?.students?.[msoItem.musicStudioAssetId._id]?.[studentIndex]?.age ? 'invalid-class' : ''}`} // Apply invalid-class conditionally
                                                {...register(`students[${msoItem.musicStudioAssetId._id}][${studentIndex}].age`, {
                                                    // Apply validation if checkbox is selected
                                                    validate: selectedItems[msoItem._id] ? (value) => validateAge(value) : undefined,
                                                })}
                                                placeholder="Student Age"
                                            />
                                        </td>

                                        {/* Email input field with validation */}
                                        <td className="student-name-input-wrapper">
                                            <input type="email"
                                                className={`student-name-input ${errors?.students?.[msoItem.musicStudioAssetId._id]?.[studentIndex]?.email ? 'invalid-class' : ''}`} // Apply invalid-class conditionally
                                                {...register(`students[${msoItem.musicStudioAssetId._id}][${studentIndex}].email`, {
                                                    // Apply validation if checkbox is selected
                                                    validate: selectedItems[msoItem._id] ? (value) => validateEmail(value) : undefined,
                                                })}
                                                placeholder="Student Email"
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
}
                    </div>
                ))}
            </div>

            <div className='guest-action-wrapper'>
                <div className='guest-action'>
                    <button className={'guest-action-btn' + ((isRequestAlive || Object.keys(errors).length) ? ' in-valid' : '')} type='submit' disabled={isRequestAlive || Object.keys(errors).length}>
                        proceed to payment
                    </button>
                </div>
            </div>
        </form>
    )
}

export default GuestRegistration;